<template>
  <div id="notFound">
    <div class="inner">
      <h1 class="colorRed"><span>404 ERRER</span></h1>
      <p>PAGE NOT FOUND</p>
      <router-link to="/">GO MAIN</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style lang="scss" scoped>
#notFound {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-bottom: 10%;
  font-size: 1.5em;
  text-align: center;
  background-color: $bg-default;
  h1 {
    position: relative;
    margin-bottom: 0.3em;
    font-size: 3em;
    span {
      display: inline-block;
      padding-left: 0.5em;
      padding-right: 0.5em;
      color: $color-white;
      background-color: $color-red;
    }
  }
}
</style>
